import { gql } from '@apollo/client';

export const GET_ANIMATIONS = gql`
  query GetAnimations($where: AnimationWhereInput, $sort: SortOrderInput) {
    getAnimations(where: $where, sort: $sort) {
      id
      cdnURL
      layer
      position
      bodyPosition
      type
      wearable {
        id
        intID
      }
      wearableAnimationsToHide {
        id
        intID
      }
    }
  }
`;
